<div class="skidinfo-layout">

    <!-- ── Scrollable content area ── -->
    <div class="skidinfo-scroll">
        <form [formGroup]="blockScheduleForm" (ngSubmit)="onSubmit()">

            <!-- ── Basic Information ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Basic Information</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label for="skidConfiguration" class="modal-label">MV Power Station Configuration</label>
                        <p-select formControlName="skidConfiguration" [options]="skidConfigOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="shipDate" class="modal-label">Ship Date</label>
                        <p-datePicker formControlName="shipDate" showIcon="true" dateFormat="mm/dd/yy" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="arrivalDate" class="modal-label">Arrival Date</label>
                        <p-datePicker formControlName="arrivalDate" showIcon="true" dateFormat="mm/dd/yy" class="w-full" />
                    </div>
                </div>
            </div>

            <!-- ── Additional Information ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Additional Information</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label for="billoflading" class="modal-label">Bill of Lading</label>
                        <input pInputText id="billoflading" formControlName="billoflading" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="shippingStatus" class="modal-label">Shipping Status</label>
                        <p-select formControlName="shippingStatus" [options]="shipStatusOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="deliveryDate" class="modal-label">Delivery Date</label>
                        <p-datePicker formControlName="deliveryDate" showIcon="true" dateFormat="mm/dd/yy" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="appointmentTime" class="modal-label">Appointment Time</label>
                        <p-datePicker formControlName="appointmentTime" [showIcon]="true" [timeOnly]="true"
                            [showTime]="true" hourFormat="12" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="skid-checkbox-row">
                            <p-checkbox id="overWeight" formControlName="overWeight" [binary]="true" />
                            <label for="overWeight" class="modal-label">Over Weight</label>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="skid-checkbox-row">
                            <p-checkbox id="overDimension" formControlName="overDimension" [binary]="true" />
                            <label for="overDimension" class="modal-label">Over Dimension</label>
                        </div>
                    </div>
                    <div class="col-12">
                        <label for="logisticsComment" class="modal-label">Logistics Comment</label>
                        <textarea pInputTextarea id="logisticsComment" formControlName="logisticsComment"
                            rows="3" class="w-full"></textarea>
                    </div>
                </div>
            </div>

            <!-- ── Integrator Information ── -->
            <div class="skid-section">
                <h4 class="skid-section-title">Integrator Information</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label for="integratorSkidSerialNo" class="modal-label">TMEIC-Integrator Serial No.</label>
                        <input pInputText id="integratorSkidSerialNo" formControlName="integratorSkidSerialNo" class="w-full" readonly />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="customerSkidNumber" class="modal-label">Customer MV Power Station Number</label>
                        <input pInputText id="customerSkidNumber" formControlName="customerSkidNumber" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv1SerialNo" class="modal-label">Inverter 1 Serial No</label>
                        <input pInputText id="inv1SerialNo" formControlName="inv1SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv1Igbt" class="modal-label">Inverter 1 IGBT</label>
                        <p-select formControlName="inv1Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv2SerialNo" class="modal-label">Inverter 2 Serial No</label>
                        <input pInputText id="inv2SerialNo" formControlName="inv2SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv2Igbt" class="modal-label">Inverter 2 IGBT</label>
                        <p-select formControlName="inv2Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv3SerialNo" class="modal-label">Inverter 3 Serial No</label>
                        <input pInputText id="inv3SerialNo" formControlName="inv3SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv3Igbt" class="modal-label">Inverter 3 IGBT</label>
                        <p-select formControlName="inv3Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv4SerialNo" class="modal-label">Inverter 4 Serial No</label>
                        <input pInputText id="inv4SerialNo" formControlName="inv4SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv4Igbt" class="modal-label">Inverter 4 IGBT</label>
                        <p-select formControlName="inv4Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv5SerialNo" class="modal-label">Inverter 5 Serial No</label>
                        <input pInputText id="inv5SerialNo" formControlName="inv5SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv5Igbt" class="modal-label">Inverter 5 IGBT</label>
                        <p-select formControlName="inv5Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv6SerialNo" class="modal-label">Inverter 6 Serial No</label>
                        <input pInputText id="inv6SerialNo" formControlName="inv6SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv6Igbt" class="modal-label">Inverter 6 IGBT</label>
                        <p-select formControlName="inv6Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv7SerialNo" class="modal-label">Inverter 7 Serial No</label>
                        <input pInputText id="inv7SerialNo" formControlName="inv7SerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="inv7Igbt" class="modal-label">Inverter 7 IGBT</label>
                        <p-select formControlName="inv7Igbt" [options]="igbtOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="scu" class="modal-label">SCU Installed?</label>
                        <p-select formControlName="scu" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="dis" class="modal-label">DIS Installed?</label>
                        <p-select formControlName="scu" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="epanb" class="modal-label">EPANB Installed?</label>
                        <p-select formControlName="epanb" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="dcFuses" class="modal-label">DC Fuses Installed?</label>
                        <p-select formControlName="dcFuses" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="wildlifeRepellentAdded" class="modal-label">Wildlife Repellent Added</label>
                        <p-select formControlName="wildlifeRepellentAdded" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="wildlifeWarningLabelApplied" class="modal-label">Wildlife Warning Label Applied</label>
                        <p-select formControlName="wildlifeWarningLabelApplied" [options]="checkOptions" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="estimatedDeliveryDate" class="modal-label">Estimated Delivery Date</label>
                        <p-datePicker formControlName="estimatedDeliveryDate" showIcon="true" dateFormat="mm/dd/yy" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="mvXfmrDesign" class="modal-label">MV Xfmr Design (kVA)</label>
                        <input pInputText id="mvXfmrDesign" formControlName="mvXfmrDesign" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="mvXfmrSerialNo" class="modal-label">MV Xfmr Serial No</label>
                        <input pInputText id="mvXfmrSerialNo" formControlName="mvXfmrSerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="lvXfmrSerialNo" class="modal-label">LV Xfmr Serial No</label>
                        <input pInputText id="lvXfmrSerialNo" formControlName="lvXfmrSerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="bushingSize" class="modal-label">Bushing Size</label>
                        <p-inputNumber id="bushingSize" formControlName="bushingSize" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="scadaSerialNo" class="modal-label">SCADA Serial No</label>
                        <input pInputText id="scadaSerialNo" formControlName="scadaSerialNo" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="trackerSerialNo1" class="modal-label">Tracker Serial No 1</label>
                        <input pInputText id="trackerSerialNo1" formControlName="trackerSerialNo1" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="trackerSerialNo2" class="modal-label">Tracker Serial No 2</label>
                        <input pInputText id="trackerSerialNo2" formControlName="trackerSerialNo2" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label for="skidStatus" class="modal-label">MV Power Station Status</label>
                        <p-select formControlName="skidStatus" [options]="skidStatusOptions" class="w-full" />
                    </div>
                    <div class="col-12">
                        <label for="notes" class="modal-label">Notes</label>
                        <textarea pInputTextarea id="notes" formControlName="notes" rows="4" class="w-full"></textarea>
                    </div>
                </div>
            </div>

        </form>
    </div>

    <!-- ── Docked footer ── -->
    <div class="skidinfo-footer">
        <button type="button" class="modal-btn-cancel" (click)="onCancel()">Cancel</button>
    </div>

</div>
